<template>
  <div class="select-time-modal">
    <div class="confirm-booking two">
      <div
        data-w-id="99838f49-2ad8-3699-7701-8f36759ef62d"
        @click="cancel"
        class="link-block-5 w-inline-block"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="modal-heading">
        <h1 class="modal-heading">Select preferred slot</h1>
      </div>
      <div class="text-block-57-slot">
        You can select <strong>only one</strong> slot, this depends on your
        preferred duration.<a href="" class="link-8"></a>
      </div>
      <div class="div-block-168">
        <div class="div-block-169-other">
          <!--          Tue, May 03-->
          <div class="text-block-96">
            {{ formatDate(new Date(selectedDateFromModal)) }}
          </div>
          <div
            data-w-id="4aff3096-a8d8-6b56-9fc1-db1b77cab290"
            class="text-block-95"
            @click="showDateModal"
          >
            Change date
          </div>
        </div>
        <div>
          <div class="w-layout-grid grid">
            <div
              href=""
              @click="getActionDiv(index)"
              style="text-decoration: none;"
              v-for="(group, index) in dailyTimeGroups"
              :key="index"
            >
              <div
                :class="
                  index === isActive
                    ? 'div-block-170-active w-inline-block'
                    : 'div-block-170 w-inline-block'
                "
                @click="showSlots(group)"
              >
                {{ formatHours(new Date(group.availableTimeStartTime)) }}:{{
                  formatMinutes(new Date(group.availableTimeStartTime))
                }}
                -
                {{ formatHours(new Date(group.availableTimeEndTime)) }}:{{
                  formatMinutes(new Date(group.availableTimeEndTime))
                }}
                {{ formatTime(new Date(group.availableTimeEndTime)) }}
              </div>
            </div>
          </div>
        </div>
        <div
          data-w-id="2ee59c6d-dd91-b5c3-bc35-2452257de4cb"
          class="button-15 select-time w-button"
          @click="trigger"
        >
          Continue
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import AvailableTimeRequest from "@/model/requests/AvailableTimeRequest";
import moment from "moment";

export default {
  name: "SelectTimeGroupModal",
  data() {
    return {
      dayModel: AvailableTimeRequest.readByDate,
      show: false,
      isActive: -1,
      slotModel: AvailableTimeRequest.readByAvailableTimeGroupId
    };
  },
  props: {
    cancel: Function,
    trigger: Function,
    showDateModal: Function
  },
  computed: {
    ...mapState({
      selectedDateFromModal: state => state.availability.selectedDateFromModal,
      dailyTimeGroups: state => state.availability.dailyTimeGroups,
      singleProfessional: state => state.professional.singleProfessional,
      professionalId: state => state.professional.professionalId
    })
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    getActionDiv(obj) {
      this.isActive = obj;
    },
    showGroup() {},
    showSlots(value) {
      // this.slotModel.availableTimeGroupId = value.availableTimeGroupId;
      // StoreUtils.dispatch(
      //   "availability/readByAvailableTimeGroupId",
      //   this.slotModel
      // );
      StoreUtils.commit("availability/setSelectedSlot", value);
      StoreUtils.commit("availability/setSelectedTimeGroup", value);
    }
  },
  mounted() {
    this.dayModel.professionalId = this.professionalId;
    this.dayModel.date = this.selectedDateFromModal;
    StoreUtils.dispatch("availability/readByDate", this.dayModel);
  }
};
</script>

<style scoped></style>
